// @flow

import { observer } from "mobx-react";
import React from "react";

import User from "app/models/User";

import Logo from "app/components/Logo/Logo";

import NavbarMenu from "app/components/NavbarMenu/NavbarMenu";
import VideoSearch from "app/components/VideoSearch/VideoSearch";

import "./Navbar.scss";

type Props = {
    user: ?User,
    hideSearch: boolean,
    onUrl: Function,
    theme: string,
    container?: string,
    logoType: string
};

type State = {
    search: boolean
};

const disableSearchButton = true;

@observer
export default class Navbar extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { search: false };
    }

    handleSearch() {
        this.setState({ search: !this.state.search });
    }

    render() {
        const search = this.state.search;
        const logoClasses = [
            "Navbar__logo",
            !search ? "Navbar__logo--active" : ""
        ];
        const searchClasses = [
            "Navbar__search",
            search ? "Navbar__search--active" : ""
        ];
        const container = this.props.container || "container-fluid";

        const logoUrl = window.location.pathname === "/" ? "/" : "/";

        return (
            <div className="Navbar">
                <nav>
                    <div className={container}>
                        <NavbarMenu user={this.props.user} />

                        <a href={logoUrl} className={logoClasses.join(" ")}>
                            <Logo
                                theme={this.props.theme}
                                type={this.props.logoType}
                            />
                        </a>

                        <div className={searchClasses.join(" ")}>
                            {this.renderSearchInput()}
                        </div>

                        {this.renderSearchButton()}
                    </div>
                </nav>
            </div>
        );
    }

    renderSearchInput() {
        if (this.props.hideSearch) return null;

        return (
            <VideoSearch
                autoRedirect={true}
                showMessage={true}
                onUrl={this.props.onUrl}
            />
        );
    }

    renderSearchButton() {
        if (disableSearchButton) return null;

        const search = this.state.search;
        const icon = search ? "remove" : "plus";

        return (
            <button
                type="button"
                className="Navbar__search-button"
                onClick={this.handleSearch.bind(this)}
            >
                <i className={`fa fa-${icon}`} /> {search ? "" : "New"}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Navbar/Navbar.js